<template>
  <div class="g-recaptcha" :data-sitekey="sitekey" :data-error="error"></div>
</template>
<script>
export default {
  name: 'Recaptcha',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sitekey: '6Lf5YFceAAAAAEcs_pruJDZtvI0RBJL26-CB6J72',
    };
  },
  head() {
    return {
      script: [
        {
          hid: 'recaptcha',
          src: 'https://www.google.com/recaptcha/enterprise.js',
          async: true,
          defer: true,
        },
      ],
    };
  },
};
</script>
<style>
.g-recaptcha {
  margin: 1rem 0;
}

.g-recaptcha > div::after {
  position: relative;
  content: '*';
  color: red;
  left: 4px;
}

.g-recaptcha > div {
  display: flex;
  position: relative;
}

.g-recaptcha > div > div {
  margin: auto;
}

.g-recaptcha[data-error='true']::after {
  content: 'This is required';
  color: red;
  font-size: 11px;
}
</style>
